import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';

export const onboardingSlice: Slice<{
  justCompleted: boolean;
}> = createSlice({
  name: 'onboarding',
  initialState: {
    justCompleted: false as boolean,
  },
  reducers: {
    resetOnboarding: (state) => {
      state.justCompleted = false as boolean;
    },
    setJustCompleted: (
      state,
      { payload: { justCompleted } }: PayloadAction<{ justCompleted: boolean }>
    ) => {
      state.justCompleted = justCompleted;
    },
  },
});

export const { setJustCompleted, resetOnboarding } = onboardingSlice.actions;

export const onboardingReducer = onboardingSlice.reducer;
